import { render } from "./addressDisplay.vue?vue&type=template&id=486282c2&scoped=true&ts=true"
import script from "./addressDisplay.vue?vue&type=script&lang=ts"
export * from "./addressDisplay.vue?vue&type=script&lang=ts"

import "./addressDisplay.vue?vue&type=style&index=0&id=486282c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486282c2"]])

export default __exports__